"use client";

/**
 * The bag in the colour worlds' header: the live item count (the same source
 * as the shop header) and a tap that opens the shared CartDrawer mounted by
 * MarketplaceCartShell — the same cart as /shop.
 */

import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { useSession } from "@/lib/auth/auth-client";
import { useCartStore } from "@/lib/store/cartStore";
import { Icon } from "./icons";

export default function BagButton({ className, badgeClassName }: { className?: string; badgeClassName?: string }) {
  const openCart = useCartStore((s) => s.openCart);
  const sessionId = useCartStore((s) => s.sessionId);
  const { data: session, isPending } = useSession();
  // @ts-ignore - Type instantiation is excessively deep
  const count = useQuery(api.cart.core.getCartItemCount, isPending ? "skip" : session?.user ? {} : { sessionId: sessionId || undefined }) as number | undefined;
  const n = count ?? 0;
  return (
    <button type="button" onClick={() => openCart()} aria-label={n ? `Bag, ${n} items` : "Bag"} className={className}>
      <Icon name="bag" size={19} />
      {n > 0 && <span className={badgeClassName}>{n > 99 ? "99+" : n}</span>}
    </button>
  );
}
